import Close from '@shared/assets/images/icons/close.svg?react';
import More from '@shared/assets/images/icons/more.svg?react';
import Trash from '@shared/assets/images/icons/delete.svg?react';
import Edit from '@shared/assets/images/icons/edit.svg?react';
import Key from '@shared/assets/images/icons/key.svg?react';
import Eye from '@shared/assets/images/icons/eye.svg?react';
import ClosedEye from '@shared/assets/images/icons/closed_eye.svg?react';
import Lock from '@shared/assets/images/icons/lock.svg?react';

import { IconNames, Icons } from "./types";


export const ICONS: Icons = {
  [IconNames.CLOSE]: Close,
  [IconNames.MORE]: More,
  [IconNames.TRASH]: Trash,
  [IconNames.EDIT]: Edit,
  [IconNames.KEY]: Key,
  [IconNames.EYE]: Eye,
  [IconNames.CLOSED_EYE]: ClosedEye,
  [IconNames.LOCK]: Lock,
};
